import { z } from 'zod';

export const updateQuestionParamsSchema = z.object({
  question_id: z.uuid('Invalid question ID'),
});

export const updateQuestionSchema = z.object({
  category_id: z.uuid('Invalid category ID').optional(),
  scale_id: z.uuid('Invalid scale ID').optional(),
  question: z.string().min(1, 'Question is required').optional(),
  hint: z.string().optional(),
  order_index: z.number().int().min(0).optional(),
});

export const reorderQuestionsSchema = z.object({
  questions: z
    .array(
      z.object({
        id: z.uuid('Invalid question ID'),
        order_index: z.number().int().min(0),
      }),
    )
    .min(1, 'At least one question is required'),
});

export type UpdateQuestionParamsPayload = z.infer<typeof updateQuestionParamsSchema>;
export type UpdateQuestionPayload = z.infer<typeof updateQuestionSchema>;
export type ReorderQuestionsPayload = z.infer<typeof reorderQuestionsSchema>;
